import { useApplicationContext } from '../../providers/ApplicationProvider/ApplicationProvider';

/**
 * useApi
 *
 * Custom hook to give quick access to the ClientSDK
 *
 * @returns
 */
export const useApi = () => {
    const { api } = useApplicationContext();

    return api;
};
